<template>
    <app-layout title="SOPs">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Create SOP</template>
                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button
                        v-if="form.isDirty"
                        :disabled="form.processing"
                        class="leading-none"
                        @click="showUnsavedChangesModal = true"
                    >
                        Cancel
                    </jet-tertiary-button>

                    <jet-tertiary-button
                        v-else
                        :disabled="form.processing"
                        :href="route('sops.index')"
                        class="leading-none"
                    >
                        Close
                    </jet-tertiary-button>
                </template>
            </page-header>
            
            <SopForm
                :form="form"
                class="px-3 md:px-4 lg:px-8"
            />

            <div class="px-3 md:px-4 lg:px-8 py-4">
                <SopStepsEdit
                    :form="form"
                />
            </div>
        </form>

        <unsaved-changes-modal-2
            :formRoute="formRoute"
            :isDirty="form.isDirty"
            :show="showUnsavedChangesModal"
            @close="showUnsavedChangesModal = false"
            @confirm="$inertia.get(route('sops.index'))"
        />
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import SopForm from '@/Pages/SOP/Partials/SopForm.vue';
import SopStepsEdit from '@/Pages/SOP/Partials/SopStepsEdit.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import UnsavedChangesModal2 from '@/Shared/UnsavedChangesModal2';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    components: {
        AppLayout,
        PageHeader,
        SopForm,
        SopStepsEdit,
        JetButton,
        JetTertiaryButton,
        UnsavedChangesModal2,
    },

    setup() {
        const form = useForm({
            id: null,
            title: null,
            description: null,
            sop_steps: [],
        })

        return { form }
    },

    data() {
        return {
            formRoute: this.route('sops.store'),
            showUnsavedChangesModal: false,
        }
    },

    methods: {
        handleSubmit () {
            if(!this.form.processing){
                this.form.post(route('sops.store'));
            }
        },
    }
}

</script>